import type Transition from '@ember/routing/transition';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import {
  TEAM_INBOX_GATE,
  TEAM_INBOX_PERMISSION,
} from 'uplisting-frontend/helpers/can-see-team-inbox';
import type SidebarBookingsInternalMessagesController from 'uplisting-frontend/pods/-sidebar/bookings/internal-messages/controller';

export default abstract class SidebarBookingsInternalMessagesRoute extends PermittedRoute {
  abstract parentRoute: string;

  permission = TEAM_INBOX_PERMISSION;
  featureFlag = TEAM_INBOX_GATE;

  model(): ModelRegistry['booking'] {
    return this.modelFor(this.parentRoute) as ModelRegistry['booking'];
  }

  setupController(
    controller: SidebarBookingsInternalMessagesController,
    model: ModelRegistry['booking'],
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    controller.booking = model;
    controller.loadThread.perform(model);
  }
}
